import { IconDots } from '@tabler/icons-react';
import React, { useState } from 'react';
import Chart from "react-apexcharts";

const InfluencerGraph = () => {
    const [series, setSeries] = useState([{
        name: "Clicks",
        data: [30, 40, 35, 50, 19, 40, 75, 60, 15, 60, 45, 5]
    }, {
        name: "App Installation",
        data: [20, 30, 15, 35, 69, 30, 45, 40, 10, 50, 35, 10]
    }, {
        name: "Amount Spent",
        data: [10, 20, 5, 25, 30, 20, 35, 30, 15, 45, 25, 5]
    }, {
        name: "Deposit",
        data: [5, 10, 15, 10, 20, 15, 25, 20, 5, 25, 15, 10]
    }, {
        name: "Registration",
        data: [1, 5, 3, 10, 15, 5, 10, 5, 3, 10, 5, 1]
    }
    ]);

    const [options, setOptions] = useState({
        chart: {
            height: 350,
            type: 'area',
            toolbar: {
                show: false
            },
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            curve: 'smooth'
        }, fill: {
            type: "gradient",
            gradient: {
                shadeIntensity: 1,
                opacityFrom: 1,
                opacityTo: 0,
                gradientToColors: ["transparent"],
                stops: [0, 100]
            }
        },
        colors: ['#0075FF', '#15BC00', '#9747FF', '#F15A24', '#2CD9FF'],
        xaxis: {
            type: 'string',
            categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            axisBorder: {
                show: false,
            },
            axisTicks: {
                show: false,
            },
            labels: {
                style: {
                    colors: 'var(--secondary-text)'
                }
            }
        },
        yaxis: {
            labels: {
                style: {
                    colors: 'var(--secondary-text)'
                }
            }
        },
        tooltip: {

        },
        legend: {
            labels: {
                show: true,
                colors: 'white'
            }
        },
        grid: {
            strokeDashArray: 6,
            column: {
                colors: undefined,
                opacity: 0.1
            },
        }
    })

    return (
        <div className='global-gradient p-1.5 rounded-xl h-full'>
            <div className="flex justify-between items-center p-1 gap-2">
                <p className='mb-0 text-sm font-medium'>Register User</p>
                <div className='flex ms-auto gap-2'>
                    <div className='text-xs font-medium mb-0 bg-[var(--primary)] px-2 py-0.5 rounded-md'>Today</div>
                    <p className='text-xs font-medium mb-0 bg-[var(--deselect-btn-bg)] px-2 py-0.5 rounded-md'>7 Days</p>
                    <p className='text-xs font-medium mb-0 bg-[var(--deselect-btn-bg)] px-2 py-0.5 rounded-md'>Month</p>
                </div>
                <IconDots className='cursor-pointer' />
            </div>
            <Chart options={options} series={series} height={'90%'} type="area" />
        </div>
    )
}

export default InfluencerGraph
